var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoweredByGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 41.159,
    viewBox: "0 0 125 41.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Powered_by_GB_-_Memphis",
    "data-name": "Powered by GB - Memphis",
    transform: "translate(-739 -129)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 125,
    height: 41.159,
    rx: 8,
    transform: "translate(739 129)",
    fill: "#ae007b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(744.335 138.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13349",
    "data-name": "Path 13349",
    d: "M16.673,12V20.6a.206.206,0,0,1-.206.206H4.326a.206.206,0,0,0-.206.206h0v2.576a.206.206,0,0,0,.206.206H19.608a.206.206,0,0,0,.206-.206V12a.206.206,0,0,0-.206-.206H16.879A.213.213,0,0,0,16.673,12Z",
    transform: "translate(-0.98 -2.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13350",
    "data-name": "Path 13350",
    d: "M14.307,6.935H8.446a.206.206,0,0,0-.206.206v8.582a.206.206,0,0,0,.206.206h5.861a.206.206,0,0,0,.206-.206V13.132a.206.206,0,0,0-.206-.206H11.571a.213.213,0,0,1-.206-.206V10.129a.206.206,0,0,1,.206-.206H17.44a.206.206,0,0,0,.206-.2h0V4.146a.206.206,0,0,0-.206-.206H14.711a.206.206,0,0,0-.206.206V6.73A.206.206,0,0,1,14.307,6.935Z",
    transform: "translate(-1.96 -0.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13351",
    "data-name": "Path 13351",
    d: "M12.553,2.8V.206A.206.206,0,0,0,12.348,0H.206A.206.206,0,0,0,0,.206V17.8A.206.206,0,0,0,.206,18H2.942a.206.206,0,0,0,.2-.206h0V3.2A.206.206,0,0,1,3.346,3h9a.206.206,0,0,0,.206-.206Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M31.468,5.8V8.771h-1V1.149h2.8a2.8,2.8,0,0,1,1.951.648,2.172,2.172,0,0,1,.7,1.684,2.134,2.134,0,0,1-.686,1.7,2.957,2.957,0,0,1-1.982.595Zm0-.816h1.8A1.791,1.791,0,0,0,34.494,4.6a1.387,1.387,0,0,0,.427-1.09,1.448,1.448,0,0,0-.427-1.09A1.692,1.692,0,0,0,33.321,2H31.468Z",
    transform: "translate(-7.246 -0.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M46.1,5.2a4.7,4.7,0,0,1-.373,1.951,2.828,2.828,0,0,1-1.067,1.265,3.155,3.155,0,0,1-3.194,0,3.049,3.049,0,0,1-1.082-1.258A4.451,4.451,0,0,1,40,5.267V4.718a4.657,4.657,0,0,1,.373-1.928A2.927,2.927,0,0,1,41.448,1.5a3.1,3.1,0,0,1,3.194,0,2.82,2.82,0,0,1,1.075,1.273A4.68,4.68,0,0,1,46.1,4.718Zm-1-.488a3.377,3.377,0,0,0-.526-2.073,1.98,1.98,0,0,0-3.049,0,3.3,3.3,0,0,0-.564,2V5.2a3.4,3.4,0,0,0,.564,2.058,1.791,1.791,0,0,0,1.524.762,1.768,1.768,0,0,0,1.524-.709,3.369,3.369,0,0,0,.541-2.02Z",
    transform: "translate(-9.512 -0.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M52.457,6.366l.145,1,.213-.9L54.34,1.13h.846L56.65,6.465l.206.915L57,6.366l1.174-5.191h1.037L57.374,8.8h-.915L54.866,3.241l-.122-.579-.107.579L53.014,8.767H52.1L50.27,1.145h1Z",
    transform: "translate(-11.954 -0.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M68.741,5.266H65.448V7.949h3.811v.823H64.45V1.15h4.771V2H65.448V4.443h3.293Z",
    transform: "translate(-15.327 -0.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M76.222,5.693H74.446V8.742H73.44V1.12h2.508a2.98,2.98,0,0,1,1.974.671,2.111,2.111,0,0,1,.694,1.7,2.02,2.02,0,0,1-.389,1.235,2.287,2.287,0,0,1-1.059.762l1.776,3.224v.061H77.876Zm-1.776-.816H75.97a1.73,1.73,0,0,0,1.189-.389A1.319,1.319,0,0,0,77.6,3.46a1.4,1.4,0,0,0-.419-1.082A1.761,1.761,0,0,0,75.97,2H74.446Z",
    transform: "translate(-17.464 -0.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M87.391,5.266H84.1V7.949h3.811v.823H83.1V1.15h4.771V2H84.06V4.443h3.293Z",
    transform: "translate(-19.762 -0.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M92.09,8.772V1.15h2.142a3.46,3.46,0,0,1,1.753.442,2.935,2.935,0,0,1,1.174,1.273,4.055,4.055,0,0,1,.419,1.86V5.2a4.1,4.1,0,0,1-.412,1.883A2.912,2.912,0,0,1,95.985,8.33a3.689,3.689,0,0,1-1.791.442ZM93.1,2V7.949h1.052a2.287,2.287,0,0,0,1.8-.716,2.98,2.98,0,0,0,.648-2.05V4.74a3.049,3.049,0,0,0-.6-2.012,2.18,2.18,0,0,0-1.723-.762Z",
    transform: "translate(-21.899 -0.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M106.81,8.77V1.148h2.485a2.889,2.889,0,0,1,1.852.511,1.837,1.837,0,0,1,.625,1.524,1.524,1.524,0,0,1-.3.938,1.875,1.875,0,0,1-.823.633,1.761,1.761,0,0,1,.976.655,1.883,1.883,0,0,1,.358,1.151,2.02,2.02,0,0,1-.663,1.6,2.752,2.752,0,0,1-1.875.587Zm1.006-4.352h1.524a1.593,1.593,0,0,0,1.037-.335,1.113,1.113,0,0,0,.389-.884,1.09,1.09,0,0,0-.366-.915A1.776,1.776,0,0,0,109.295,2h-1.479Zm0,.762V7.908h1.646a1.585,1.585,0,0,0,1.105-.358,1.28,1.28,0,0,0,.4-1c0-.915-.5-1.372-1.524-1.372Z",
    transform: "translate(-25.4 -0.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M118.25,5l1.982-3.811h1.136l-2.614,4.764V8.781h-1V5.954L115.14,1.19h1.143Z",
    transform: "translate(-27.381 -0.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M37.225,24.307a3.3,3.3,0,0,1-1.41.861,6,6,0,0,1-2.035.328,3.605,3.605,0,0,1-2.721-1.044A4.207,4.207,0,0,1,30,21.555v-.762a5.145,5.145,0,0,1,.457-2.233,3.377,3.377,0,0,1,1.288-1.471,3.674,3.674,0,0,1,1.951-.511,3.811,3.811,0,0,1,2.515.762,3.117,3.117,0,0,1,1.044,2.21h-2.05a1.608,1.608,0,0,0-.465-1.037,1.524,1.524,0,0,0-1.006-.312,1.38,1.38,0,0,0-1.22.671,3.628,3.628,0,0,0-.434,1.905V21.3a3.552,3.552,0,0,0,.442,1.951,1.57,1.57,0,0,0,1.4.648,1.745,1.745,0,0,0,1.212-.366V22.18H33.681V20.747h3.544Z",
    transform: "translate(-7.134 -3.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M45.294,22.35H44.158V25.4H42.07V16.748h3.415a3.811,3.811,0,0,1,2.409.686,2.287,2.287,0,0,1,.869,1.928,2.828,2.828,0,0,1-.366,1.524,2.584,2.584,0,0,1-1.143.96l1.806,3.476v.084H46.818Zm-1.136-1.6h1.326a1.159,1.159,0,0,0,.892-.312,1.412,1.412,0,0,0,0-1.753,1.181,1.181,0,0,0-.892-.32H44.158Z",
    transform: "translate(-10.004 -3.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M58.245,23.8h-2.9l-.5,1.616H52.62L55.8,16.75h1.966l3.2,8.666H58.679Zm-2.363-1.616h1.829l-.93-3Z",
    transform: "translate(-12.513 -3.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M72.323,22.442a3.193,3.193,0,0,1-.488,1.6,2.927,2.927,0,0,1-1.25,1.075,4.337,4.337,0,0,1-1.845.381,3.407,3.407,0,0,1-2.691-1.113,4.573,4.573,0,0,1-.983-3.148v-.427a5.2,5.2,0,0,1,.442-2.226,3.376,3.376,0,0,1,1.28-1.479,3.514,3.514,0,0,1,1.928-.518,3.7,3.7,0,0,1,2.53.831,3.239,3.239,0,0,1,1.09,2.287H70.257a1.57,1.57,0,0,0-.4-1.136,1.654,1.654,0,0,0-1.143-.351,1.242,1.242,0,0,0-1.143.587,3.689,3.689,0,0,0-.381,1.86v.617a4.207,4.207,0,0,0,.343,1.982,1.281,1.281,0,0,0,1.2.595,1.616,1.616,0,0,0,1.1-.335,1.425,1.425,0,0,0,.4-1.082Z",
    transform: "translate(-15.471 -3.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M82.253,21.742H78.968V23.8h3.887v1.6H76.88V16.75h5.983v1.616H78.968V20.2h3.285Z",
    transform: "translate(-18.282 -3.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M86.83,25.413V16.747h3.11a4.436,4.436,0,0,1,2.546.61,2.287,2.287,0,0,1,.572,2.934,1.791,1.791,0,0,1-.915.7,1.86,1.86,0,0,1,1.044.663,1.944,1.944,0,0,1,.366,1.2,2.287,2.287,0,0,1-.808,1.913,3.811,3.811,0,0,1-2.393.648Zm2.088-5.053h1.09a1.524,1.524,0,0,0,.976-.252.9.9,0,0,0,.29-.724.93.93,0,0,0-.313-.762,1.707,1.707,0,0,0-1.021-.244H88.918Zm0,1.372V23.8h1.364a1.349,1.349,0,0,0,.877-.259.922.922,0,0,0,.3-.762.96.96,0,0,0-1.075-1.09Z",
    transform: "translate(-20.649 -3.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M100.228,23.8h3.636v1.6H98.14V16.75h2.088Z",
    transform: "translate(-23.338 -3.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M114.564,21.219a5.153,5.153,0,0,1-.465,2.248,3.476,3.476,0,0,1-1.341,1.524,3.986,3.986,0,0,1-3.933,0,3.453,3.453,0,0,1-1.341-1.456,4.954,4.954,0,0,1-.5-2.172v-.488a5.244,5.244,0,0,1,.465-2.248,3.476,3.476,0,0,1,1.341-1.524,3.811,3.811,0,0,1,1.989-.534,3.719,3.719,0,0,1,1.966.526,3.552,3.552,0,0,1,1.341,1.524,4.893,4.893,0,0,1,.48,2.218Zm-2.119-.366a3.643,3.643,0,0,0-.434-1.959,1.38,1.38,0,0,0-1.235-.671c-1.052,0-1.6.762-1.662,2.363v.633a3.735,3.735,0,0,0,.427,1.959,1.471,1.471,0,0,0,2.477,0,3.735,3.735,0,0,0,.434-1.936Z",
    transform: "translate(-25.44 -3.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M126.269,22.442a3.117,3.117,0,0,1-.488,1.6,2.927,2.927,0,0,1-1.25,1.075,4.314,4.314,0,0,1-1.845.381A3.407,3.407,0,0,1,120,24.386a4.573,4.573,0,0,1-1-3.148v-.427a5.2,5.2,0,0,1,.442-2.226,3.377,3.377,0,0,1,1.281-1.479,3.529,3.529,0,0,1,1.928-.518,3.727,3.727,0,0,1,2.538.831,3.27,3.27,0,0,1,1.09,2.287h-2.088a1.524,1.524,0,0,0-.4-1.136,1.654,1.654,0,0,0-1.143-.351,1.258,1.258,0,0,0-1.143.587,3.689,3.689,0,0,0-.381,1.86v.617a4.093,4.093,0,0,0,.351,1.982,1.265,1.265,0,0,0,1.2.595,1.654,1.654,0,0,0,1.105-.335,1.456,1.456,0,0,0,.4-1.082Z",
    transform: "translate(-28.296 -3.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M133.78,22.192l-.861.938v2.287H130.83V16.75h2.088v3.811l.762-1.105,1.852-2.706h2.584l-2.927,3.811,2.927,4.832h-2.477Z",
    transform: "translate(-31.112 -3.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M146.448,23.076a.876.876,0,0,0-.328-.716,4.062,4.062,0,0,0-1.143-.526,10.716,10.716,0,0,1-1.334-.534,2.53,2.53,0,0,1-1.684-2.287,2.073,2.073,0,0,1,.419-1.273,2.7,2.7,0,0,1,1.189-.838,4.573,4.573,0,0,1,1.73-.312,4.062,4.062,0,0,1,1.677.335,2.637,2.637,0,0,1,1.151.953,2.462,2.462,0,0,1,.412,1.4h-2.088a1.037,1.037,0,0,0-.32-.816,1.258,1.258,0,0,0-.877-.3,1.4,1.4,0,0,0-.884.252.727.727,0,0,0,.031,1.235,4.573,4.573,0,0,0,1.258.556,7.156,7.156,0,0,1,1.471.625,2.477,2.477,0,0,1,1.41,2.233,2.119,2.119,0,0,1-.861,1.784,3.811,3.811,0,0,1-2.348.648,4.573,4.573,0,0,1-1.913-.381,2.874,2.874,0,0,1-1.28-1.029,2.7,2.7,0,0,1-.434-1.524h2.1a1.319,1.319,0,0,0,.358,1.021,1.715,1.715,0,0,0,1.174.335,1.364,1.364,0,0,0,.816-.221.762.762,0,0,0,.3-.625Z",
    transform: "translate(-33.697 -3.945)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredByGb);
export default __webpack_public_path__ + "static/media/Powered_by_GB.33e0f6b8816e67ab2dbdb374c379c1d4.svg";
export { ForwardRef as ReactComponent };